import { render, staticRenderFns } from "./MtCollectsModal.vue?vue&type=template&id=68be1446&"
import script from "./MtCollectsModal.vue?vue&type=script&lang=js&"
export * from "./MtCollectsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports